export default __webpack_public_path__ + "static/media/foamfrat.bfc9710b.png";